import {
  SCREENER_FACILITY_VIEW_KIND,
  useScreenerFacilityView
} from '@/hooks/facility-selection/useScreenerFacilityView';

import { useInboundFacilities } from '../Inbound/hooks/useInboundFacilities';

export type InboundDocumentsAvailability =
  | { status: 'loading' }
  | { status: 'error'; retry: () => void }
  | { status: 'enabled' }
  | { status: 'disabled' };

export function useIsInboundDocumentsEnabled(): InboundDocumentsAvailability {
  const { view, selectedFacilityId } = useScreenerFacilityView();
  const { facilities, isLoading, isError, retry } = useInboundFacilities();
  if (isError) {
    return { status: 'error', retry };
  }
  if (isLoading) {
    return { status: 'loading' };
  }
  const isEnabled = facilities.some((facility) =>
    view.kind === SCREENER_FACILITY_VIEW_KIND.AllFacilities
      ? facility.facility_type === view.facilityType
      : facility.id === selectedFacilityId
  );
  return { status: isEnabled ? 'enabled' : 'disabled' };
}
